<template>
    <div>

        <div v-if="isLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h2>Risk Audits</h2>
                    </div>
                    <div class="widget-body border-bottom">
                        <router-link to="/risk-audits/add"
                                     class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3"
                                     style="display:block;width:100%">Start New Risk Audit
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3 class="d-none">
                            Risk Audits ({{ riskAudits.length }})</h3>
                        <h3 id="no-risk-audits">
                            Risk Audits ({{ filteredCount }})</h3>
                    </div>
                    <div class="widget-body">
                        <div class="input-group pb-5">
                        <span class="input-group-addon pr-0 pl-0">
                        <a class="btn" href="#">
                        <i class="fa fa-search"></i>
                        </a>
                        </span>
                            <input type="text" class="form-control dynamic-search" name="search_term"
                                   v-model="search"
                                   placeholder="Search (enter at least 3 characters)">
                        </div>


                        <div class="container">

                            <risk-audit
                                    v-for="riskAudit in riskAudits"
                                    v-bind:key="riskAudit.site_risk_audit_id"
                                    v-bind:riskAudit="riskAudit"
                            >
                            </risk-audit>


                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import RiskAudit from '@/components/RiskAudit.vue';

    export default {
        data() {
            return {
                riskAudits: [],
                isLoading: true,
                search: ''
            }
        },
        components: {
          RiskAudit,
        },
        computed: {
            filteredReports() {
                // if (this.riskAudits !== null) {
                //     return this.riskAudits.filter(riskAudit => {
                //         return doorCheck.document_id.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                //             || doorCheck.document_title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                //     });
                // }
                return this.riskAudits;
            },
            filteredCount() {
                return this.filteredReports.length;
            }
        },
        mounted() {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FRA') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getRiskAudits();
        },
        methods: {
            getRiskAudits() {
                var vmt = this;
                this.getDb(function onConnected(db) {
                    var vm = vmt;
                    vm.riskAudits = [];
                    try {
                        var objectStore = db.transaction('risk_assessments').objectStore('risk_assessments');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                vm.isLoading = false;
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.riskAudits) {
                                        if (
                                            (cursor.value.is_deleted === undefined || cursor.value.is_deleted === false) &&
                                            (cursor.value.is_complete === undefined || cursor.value.is_complete === false)
                                        ) {
                                            vm.riskAudits.push(cursor.value)
                                        }
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                    }
                });
            }
        }
    }
</script>